/**
 * Enum representing different positions where toasts can appear on the screen.
 * Each value corresponds to a specific position like 'top-left', 'top-right', etc.
 */
export enum ToastPosition {
  /**
   * Top-left position:
   * Toast will appear at the top-left corner of the screen.
   */
  TopLeft = 'top-left',

  /**
   * Top-center position:
   * Toast will appear at the top-center of the screen.
   */
  TopCenter = 'top-center',

  /**
   * Top-right position:
   * Toast will appear at the top-right corner of the screen.
   */
  TopRight = 'top-right',

  /**
   * Bottom-left position:
   * Toast will appear at the bottom-left corner of the screen.
   */
  BottomLeft = 'bottom-left',

  /**
   * Bottom-center position:
   * Toast will appear at the bottom-center of the screen.
   */
  BottomCenter = 'bottom-center',

  /**
   * Bottom-right position:
   * Toast will appear at the bottom-right corner of the screen.
   */
  BottomRight = 'bottom-right',
}
